export const SET_CART = 'SET_CART';
export const SET_KEYWORD = 'SET_KEYWORD';
export const SET_SORT = 'SET_SORT';
export const SET_PRODUCT_DATA = 'SET_PRODUCT_DATA';
export const SET_PAGE = 'SET_PAGE';
export const SET_BRAND = 'SET_BRAND';
export const SET_COLOR = 'SET_COLOR';